import { Box, Flex } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { AlertOutlineIcon } from 'Asset/icon';
import InputSelect from 'UiKit/input-select';
import InputDatepicker from 'UiKit/input-datepicker';
import InputComponent from 'UiKit/input';
import { TextBold, TextRegular } from 'UiKit/typography';
import { Condition } from 'Component/others';
import useGetScheduleForReschedule from 'Domain/reschedule/useGetScheduleForReschedule';

import styles from './styles.module.css';

const ChangeSchedule = ({ form }) => {
  const { t } = useTranslation('host-reschedule');
  const { register, watch, setValue } = form;
  const { id } = useParams();

  const { scheduleDate, targetScheduleId, host, liveAccount } = watch();

  const { data: scheduleOptions } = useGetScheduleForReschedule(id, scheduleDate);

  const handleChangeSchedule = (data) => {
    setValue('targetScheduleId', data);
    setValue('liveAccount', data?.accountLivestream);
    if (data.hosts.length < 2) setValue('host', data?.hosts[0]);
  };

  return (
    <Box className={styles['change-schedule__container']}>
      <TextBold className={styles['change-schedule__title-step-text']}>
        {t('form_swap_schedule.section_title')} <span>*</span>
      </TextBold>

      <Box className={styles['change-schedule__form--field']}>
        <InputDatepicker
          placeholder={t('form_swap_schedule.date_placeholder')}
          label={t('form_swap_schedule.date')}
          isRequired={true}
          value={scheduleDate}
          onChange={(e) => setValue('scheduleDate', e)}
          minDate={new Date(moment().add(1, 'days'))}
        />
      </Box>
      <Box className={styles['change-schedule__form--field']}>
        <InputSelect
          placeholder={t('form_swap_schedule.schedule_placeholder')}
          value={targetScheduleId}
          label={t('form_swap_schedule.schedule')}
          isRequired={true}
          options={scheduleOptions}
          onChange={handleChangeSchedule}
          minHeight="34px"
        />
      </Box>
      <Box>
        <Flex gap={'16px'}>
          <Box className={styles['change-schedule__form--field']}>
            <Condition
              statement={targetScheduleId?.hosts?.length < 2 || !targetScheduleId}
              fallback={
                <InputSelect
                  placeholder={t('form_swap_schedule.host_name')}
                  label={t('form_swap_schedule.host_name')}
                  options={targetScheduleId?.hosts}
                  onChange={(e) => setValue('host', e)}
                  minHeight="34px"
                />
              }
            >
              <InputComponent
                minHeight="34px"
                isDisabled={true}
                width={'100%'}
                placeholder={t('form_swap_schedule.host_name')}
                label={t('form_swap_schedule.host_name')}
                value={host?.name || ''}
              />
            </Condition>
          </Box>
          <Box className={styles['change-schedule__form--field']}>
            <InputComponent
              isDisabled={true}
              height="34px"
              width={'100%'}
              placeholder={t('form_swap_schedule.live_account')}
              register={{ ...register('hostName') }}
              label={t('form_swap_schedule.live_account')}
              value={liveAccount}
            />
          </Box>
        </Flex>
        <Box className={styles['change-schedule__form--field-desc']}>
          <AlertOutlineIcon color="var(--color-neutral70)" size={11} pb="2px" />
          <TextRegular className={styles['change-schedule__form--field-caption']}>
            <Condition statement={targetScheduleId?.hosts?.length < 2 || !targetScheduleId} fallback={t('form_swap_schedule.auto_fill_hint')}>
              {t('form_swap_schedule.auto_fill_hint_single')}
            </Condition>
          </TextRegular>
        </Box>
      </Box>
    </Box>
  );
};

export default ChangeSchedule;
